module.exports = __webpack_public_path__ + "img/greenTran.fa4b1928.png";